import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import Cookies, { CookieChangeListener } from 'universal-cookie';
import { TRACKING_UTM_PARAMS } from '@/analytics/CookieBanner/types';
import { Routes } from '@/helpers/utils';
import { useLocale } from '@/i18n/client';
const cookies = new Cookies();
function utmParamToCookieName(param: string) {
  return `tracking_${param.toLowerCase()}`;
}
const UTM_PARAM_COOKIE_NAMES = TRACKING_UTM_PARAMS.map(utmParamToCookieName);
function utmSearchParamsFromCookies() {
  const params = new URLSearchParams();
  for (const param of TRACKING_UTM_PARAMS) {
    const value = cookies.get<string>(utmParamToCookieName(param));
    if (!value) continue;
    params.set(param, value);
  }
  return params;
}
function useUtmParamsFromCookie() {
  const $ = _c(3);
  const [utmParams, setUtmParams] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cookie => {
      if (!UTM_PARAM_COOKIE_NAMES.includes(cookie.name)) {
        return;
      }
      setUtmParams(utmSearchParamsFromCookies());
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleCookieChange = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setUtmParams(utmSearchParamsFromCookies());
      cookies.addChangeListener(handleCookieChange);
      return () => {
        cookies.removeChangeListener(handleCookieChange);
      };
    };
    t2 = [handleCookieChange];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return utmParams;
}
function useDonationFormUrl(t0) {
  const $ = _c(8);
  const {
    fundraisingEventId
  } = t0;
  const locale = useLocale();
  const utmParams = useUtmParamsFromCookie();
  let t1;
  if ($[0] !== fundraisingEventId || $[1] !== locale) {
    t1 = new URL(Routes.donate({
      locale,
      "channel": "platform",
      "receiver-type": "fundraising-events",
      "slug": fundraisingEventId,
      "catchAll": undefined
    }));
    $[0] = fundraisingEventId;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const baseUrl = t1;
  let t2;
  bb0: {
    if (!utmParams) {
      let t3;
      if ($[3] !== baseUrl) {
        t3 = baseUrl.toString();
        $[3] = baseUrl;
        $[4] = t3;
      } else {
        t3 = $[4];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[5] !== baseUrl || $[6] !== utmParams) {
      const url = new URL(baseUrl);
      utmParams.forEach((value, key) => url.searchParams.set(key, value));
      t3 = url.toString();
      $[5] = baseUrl;
      $[6] = utmParams;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = t3;
  }
  const donationUrlWithUtmParams = t2;
  return donationUrlWithUtmParams;
}
export default useDonationFormUrl;